import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavProductProductManagers = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useProductsData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            return [
                {
                    key: "jira",
                    logo: "jira",
                    href: "/software/jira",
                    name: "Jira",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jira.description",
                            defaultMessage: "Flexible project management"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "confluence",
                    logo: "confluence",
                    href: "/software/confluence",
                    name: "Confluence",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.confluence.description",
                            defaultMessage: "Knowledge, all in one place"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "jpd",
                    logo: "jiraproductdiscovery",
                    href: "/software/jira/product-discovery",
                    name: "Jira Product Discovery",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jpd.description",
                            defaultMessage: "Capture & prioritize ideas"
                        })
                    ),
                    isNew: true
                }
            ];
        }, []);
    }

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productsproductmanagers.title",
                defaultMessage: "Products for Product Managers"
            })}
            cards={productsData}
            productKey={productKey}
        />
    );
};
